import type { Campaign } from '@/api/campaigns';

/**
 * Find a campaign by its human-readable campaign_id, with fallback
 * for old 4-part IDs (before the size suffix was removed).
 *
 * Old format: {flight_group_id}_{nameplate}_{format_type}_{size}
 * New format: {flight_group_id}_{nameplate}_{format_type}
 *
 * This allows deep-links from old Teams notifications / emails to
 * keep working after the migration.
 */
export function findCampaignByCampaignId(
  campaigns: Campaign[] | undefined,
  targetCampaignId: string,
): Campaign | undefined {
  if (!campaigns || !targetCampaignId) return undefined;

  // Exact match (new 3-part format)
  const exact = campaigns.find(c => c.campaign_id === targetCampaignId);
  if (exact) return exact;

  // Fallback: strip last segment for old 4-part IDs
  const parts = targetCampaignId.split('_');
  if (parts.length === 4) {
    const stripped = parts.slice(0, 3).join('_');
    return campaigns.find(c => c.campaign_id === stripped);
  }

  return undefined;
}
